import { useTranslation } from 'react-i18next';
import { ChevronsLeftRightIcon } from '@/components/ui/chevrons-left-right';
import { ChevronsRightLeftIcon } from '@/components/ui/chevrons-right-left';
import { cn } from '@/lib/utils';

interface SidebarCollapseToggleProps {
  readonly isCollapsed: boolean;
  readonly onToggle: () => void;
}

export function SidebarCollapseToggle({ isCollapsed, onToggle }: SidebarCollapseToggleProps) {
  const { t } = useTranslation('nav');

  return (
    <button
      type="button"
      onClick={onToggle}
      className={cn(
        'fixed top-12 z-50 flex h-7 w-7 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-border bg-background text-foreground shadow-md transition-[left] duration-300 hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        isCollapsed ? 'left-16' : 'left-64',
      )}
      aria-label={t('toggle_sidebar')}
      aria-expanded={!isCollapsed}
    >
      {isCollapsed ? (
        <ChevronsLeftRightIcon size={16} className="pointer-events-none shrink-0" aria-hidden />
      ) : (
        <ChevronsRightLeftIcon size={16} className="pointer-events-none shrink-0" aria-hidden />
      )}
    </button>
  );
}
